@if (!store.isSummary) {
    <ap-previous-button (click)="previousQuestion()"></ap-previous-button>
    <div class="bold">{{ 'financial-obligations.open-ended-credit.title' | apContent }}</div>
}

@if (showOpenEndedCreditAmount()) {
    <open-ended-credit-amount></open-ended-credit-amount>
}
